<template>
    <div class="view-body view-body--module">
      <div class="view-data">
        <div class="view-data__header view-data__header--module">
          <h1>{{title}} ({{item ? item.length : ''}})</h1>
        </div>
        <draggable class="drag-pages-area pages-grid" :disabled="blocked ? blocked : historyMode" :class="{'show-all' : showAllPages || orderedPages.length <= 13}" v-model="pages" group="pages" @change="pagesOrder">
          <div class="pages-list-item pages-list-item--mirror pages-grid__item" v-for="(element, index) in orderedPages" :key="element.id" :class="{'active' : activePage == element.id || findSelected(element.id) && tableType == 'page', 'odd' : pages ? pages.length % 2 && pages.length-1 == index : false, 'new': compareOrderPages(element), 'product-changed': compareProductOnPage(element) }" @mouseup.left.exact="prepareToCopyPage(element.id)" @mouseup.shift.left.exact="multiSelectPages(element.id)">   
              <div class="page-icon">             
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" height="100%"
                  viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
                  <path fill="#030104" d="M18,0H4v32h24V9.998L18,0z M15.918,12V4l8,8H15.918z"/>
                </svg>
                <p>{{ element.number }}</p>
              </div>
              <span v-if="historyMode" class="compare" style="color: red; text-decoration: line-through;">{{ compareOrderPageNumberChange(element) }}</span>
              <span>({{countPageElements(element)}})</span>
            <draggable class="dropZonePage" :group="{name: 'dropOnPage'}" :list="dropsOnPage" @change="drop(element)"></draggable>
          </div>
        </draggable>
        <div class="pages-buttons">
          <span v-if="!$parent.$parent.grantPermission(['ROLE_LOCAL', 'ROLE_CENTRAL'])" @click="addPage(); $emit('blockAddPage')" :class="{'disabled' : historyMode || blocked }"><img class="list-icon" src="../../assets/symbols/new-file.svg"/>Dodaj strony</span>
          <span @click="$emit('click', 'waitingRoom'); activePage = 0" :class="{'bolded' : tableType == 'waitingRoom', 'disabled' : historyMode}" style="position:relative">Poczekalnia <p>({{waitingRoom}})</p>
            <draggable class="dropZonePageTrash" :group="{name: 'dropOnPage'}" :list="dropsOnPageTrash" @change="dropOnWaiting()">waiting</draggable>
          </span>
          <draggable :group="{ name: 'pages', pull: false}" :list="pagesToRemove" @change="removePage()" style="position: relative;">
            <span @click="$emit('click', 'trash'); activePage = 0" :class="{'bolded' : tableType == 'trash', 'disabled' : historyMode}">Kosz <p>({{trashRoom}})</p></span>
            <draggable class="dropZonePageTrash" :group="{name: 'dropOnPage'}" :list="dropsOnPageTrash" @change="dropOnTrash()">trash</draggable>
          </draggable>
          <span @click="$emit('click', 'legals'); activePage = 0" :class="{'bolded' : tableType == 'legals', 'disabled' : historyMode}">Zdania prawne</span>
          <span @click="showAllPages = !showAllPages"><img class="list-arrow" :class="{'expanded' : showAllPages && orderedPages.length > 13}" src="../../assets/symbols/arrow-point-to-right.svg"/></span>
        </div>
        <div class="comments" :class="{'disabled' : historyMode || blocked}">
          <div class="view-data__header view-data__header--module">
            <h1>Komentarze ({{comments ? comments.length : 0}})</h1>
          </div>
          <ul class="comments__list">
            <li v-for="(comment, index) in comments" :key="comment.id">
              <span><p>{{index + 1}}</p><img src="../../assets/symbols/chat.svg"/></span>
              <p>{{comment.content}}</p>
            </li>
            <li class="comment-btn" @click="$emit('addComment')" v-if="activePage !== 0">
              <span><img src="../../assets/symbols/chat.svg"/></span>
              <p>Dodaj komentarz</p>
            </li>
          </ul>
        </div>
      </div>
  </div>

</template>

<script>

import debounce from "lodash.debounce";
import draggable from 'vuedraggable';
import _ from 'lodash';

export default {

  name: 'orderPages',
  components:{

    draggable,

  },
  props:{

    item:{
      type: Array,
      default: () => [],
    },

    id:{
      type: Number,
      default: 0,
    },

    switchActive:{
      type: Number,
      default: 0,
    },

    waitingRoom: {
      type: Number,
      default: 0
    },

    trashRoom: {
      type: Number,
      default: 0
    },

    blockAddPage:{
      type: Boolean,
      default: false,
    },

    tableType:{
      type: String,
      default: 'order',
    },

    historyMode:{
      type: Boolean,
      default: false,
    },

    blocked:{
      type: Boolean,
      default: false,
    },

    draggedProduct: {
      type: Object,
      default: () => {}
    },

  },
  data () {

    return {

      title: 'Strony',

      pages: [],
      originalPages: [],
      comments: [],
      activePage: 0,
      showAllPages: false,
      selectedPages: [],

      clickCounter: 0,
      emitTimer: null,

      pagesToRemove:[],
      dropsOnPage:[],
      dropsOnPageTrash:[],

      comment: '',

    }

  },
  methods:{

    drop(page){

      const token = localStorage.getItem('auth_token');

      if(!this.draggedProduct.href){

        let products = {
          products:[
            {
              id: this.draggedProduct.id
            }
          ]
        }
        
        if(this.tableType == 'order' || this.tableType == 'waitingRoom'){

          if(this.draggedProduct.page == 0){

            this.$http.post(`orders/${this.id}/waitings/${page.id}/removes`, products, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }).then(response => {

              this.dropsOnPage = [];
              this.$parent.getOrder();
              this.$parent.$refs.productsInOrder.manager();

            }).catch(error =>{

              console.error(error.response);
              this.dropsOnPage = [];

            })

          }else{

            const find = this.pages.find(page => page.number === this.draggedProduct.page);

            this.$http.put(`order-pages/${find.id}/moves/${page.id}/tos/${this.draggedProduct.id}/other/page`,{fakeObj: ''}, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
            }).then(response => {
              
              this.dropsOnPage = [];
              this.$parent.getOrder();
              this.$parent.$refs.productsInOrder.manager();

            }).catch(error =>{

              console.error(error.response);
              this.dropsOnPage = [];

            })

          }

        }

        if(this.tableType == 'page'){

          this.$http.put(`order-pages/${this.switchActive}/moves/${page.id}/tos/${this.draggedProduct.id}/other/page`,{fakeObj: ''}, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }).then(response => {
            
            this.dropsOnPage = [];
            this.$parent.getOrder();
            this.$parent.$refs.productsInOrder.manager();

          }).catch(error =>{

            console.error(error.response);
            this.dropsOnPage = [];

          })

        }

      }else{

        let images = {
          productImages:[
            {
              id: this.draggedProduct.id
            }
          ]
        }

        if(this.tableType == 'order' || this.tableType == 'waitingRoom'){

          if(this.draggedProduct.page == 0){

            this.$http.post(`orders/${this.id}/waitings/${page.id}/images/removes`, images, {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }).then(response => {

              this.dropsOnPage = [];
              this.$parent.getOrder();
              this.$parent.$refs.productsInOrder.manager();

            }).catch(error =>{

              console.error(error.response);
              this.dropsOnPage = [];

            })

          }else{

            const find = this.pages.find(page => page.number === this.draggedProduct.page);

            this.$http.post(`order-pages/${find.id}/moves/${page.id}/images`, images, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
            }).then(response => {
              
              this.dropsOnPage = [];
              this.$parent.getOrder();
              this.$parent.$refs.productsInOrder.manager();

            }).catch(error =>{

              console.error(error.response);
              this.dropsOnPage = [];

            })

          }

        }

        if(this.tableType == 'page'){

          this.$http.post(`order-pages/${this.switchActive}/moves/${page.id}/images`, images, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          }).then(response => {
            
            this.dropsOnPage = [];
            this.$parent.getOrder();
            this.$parent.$refs.productsInOrder.manager();

          }).catch(error =>{

            console.error(error.response);
            this.dropsOnPage = [];

          })

        }

      }
      
    },

    dropOnTrash(){
      
      this.$parent.$parent.uncheckAllCheckboxes();
      this.$parent.$refs.productsInOrder.selectedItems = [];
      this.$parent.$refs.productsInOrder.checkboxes(this.draggedProduct);
      this.$parent.$refs.productsInOrder.moveProductToTrash();
      
    },

    dropOnWaiting(){
      
      this.$parent.$parent.uncheckAllCheckboxes();
      this.$parent.$refs.productsInOrder.selectedItems = [];
      this.$parent.$refs.productsInOrder.checkboxes(this.draggedProduct);
      this.$parent.$refs.productsInOrder.moveProductToWaitingRoom();
      
    },

    findSelected(id){

      const selected = this.selectedPages.find(page => page.id == id);

      if(selected){
        return true;
      }

      return false;

    },

    multiSelectPages(id){

      if(!this.findSelected(id)){

        this.selectedPages.push({id: id});
        this.$emit('multiPage', this.selectedPages);

      }

    },

    prepareToCopyPage(id){

      this.selectedPages = [];
      this.$emit('multiPage', this.selectedPages);
      this.selectedPages.push({id: id});

      if(this.activePage == id){

        this.clickCounter++;

        window.setTimeout(()=>{
          this.clickCounter = 0;
          this.selectedPages = [];
        }, 200)

        if(this.clickCounter == 2){

          window.clearTimeout(this.emitTimer);

          this.$parent.$refs.productsInOrder.checkAll();
          this.clickCounter = 0;

          return;

        }

      }

      this.emitTimer = window.setTimeout(()=>{

        this.$emit('mouseup', id); 
        this.activePage = id; 
        this.$parent.$parent.uncheckAllCheckboxes();

      }, 400)

    },

    countPages(){

      this.pages = this.item;
      this.originalPages = this.item;

    },

    array_move(arr, old_index, new_index) {
      var element = arr[old_index];
      arr.splice(old_index, 1);
      arr.splice(new_index, 0, element);
    },

    pagesOrder(change){

      if ( change && change.moved ) {
        let oldIndex = change.moved.oldIndex;
        let newIndex = change.moved.newIndex;

        let elementA = this.originalPages[oldIndex];
        let elementB = this.originalPages[newIndex];

        this.pages = this.originalPages;

        this.pages.forEach((item, index)=>{
          if ( index !== oldIndex && index !== newIndex ) {
            item = this.originalPages[index];
          } 
        });

        this.pages[oldIndex] = elementB;
        this.pages[newIndex] = elementA;

      }

      for (let i = 0; i < this.pages.length; i++) {
        
        this.pages[i].orderNumber = i+1;
        this.pages[i].number = i+1;
        
      }

      const token = localStorage.getItem('auth_token');

      this.$http.put(`orders/${this.id}/pages`, this.pages, {headers: {

        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'

        } }).then(response => {


        })

    },

    compareOrderPages(element) {

      if ( this.historyMode && this.$parent.order && this.$parent.orderToCompare ) {

        let order           = this.$parent.order.orderPages;
        let orderToCompare  = this.$parent.orderToCompare.orderPages;

        if(orderToCompare){

          let find = orderToCompare.find(item => item.number === element.number);
          if ( !find ) {
            return true;
          }

        }

      }

    },

    compareOrderPageNumberChange(element){
      if ( this.historyMode && this.$parent.order && this.$parent.orderToCompare ) {

        let order           = this.$parent.order.orderPages;
        let orderToCompare  = this.$parent.orderToCompare.orderPages;
        let elementIndex    = null;

        if(orderToCompare){
        
          order.forEach((item, index)=>{
            if ( item.number == element.number ) {
              elementIndex = index;
            }
          });

          if ( orderToCompare[elementIndex] ) {
            if ( orderToCompare[elementIndex].number != element.number ) {
              return orderToCompare[elementIndex].number;
            }
          }

          return;

        }

      }
    },

    compareProductOnPage(element) {
      return false;
    },

    addPage(){

      if(!this.blockAddPage){

        const page = {
          number: this.pages.length + 1,
          orderNumber: this.pages.length + 1
        }

        const token = localStorage.getItem('auth_token');

        this.$http.post(`order-pages/${this.id}`, page, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          } }).then(response => {

            this.$parent.getOrder();

          })

      }

    },

    getPageComments(){
      
        if(!this.historyMode){
        
          const token = localStorage.getItem('auth_token');

          this.$http.get(`order-page-comments/${this.activePage}`, {
            headers: {

            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'

            }})
            .then(response => {

              this.comments = response.data;
            })
            .catch(error =>{
              
              this.comments = [];

            })

        }else{
       
          this.comments = [];

          const page = this.item.find(page => page.id == this.activePage);
          if(page) this.comments = page.comments;
          
        }

    },

    getOrderComments(){

      if(!this.historyMode){
      
        const token = localStorage.getItem('auth_token');

        this.$http.get(`orders/${this.id}/comments`, {
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }})
          .then(response => {

            this.comments = response.data;
          })
          .catch(error =>{
            
            this.comments = [];

          })

      }else{
       
        this.comments = [];

        this.item.forEach(page =>{

          if(page.comments){

            page.comments.forEach(comment=>{
              this.comments.push(comment)
            })

          }

        })
          
      }

    },

    removePage(){

      if(!this.historyMode || !this.blocked){

        const token = localStorage.getItem('auth_token');

        this.$http.post(`order-pages/${this.pagesToRemove[0].id}/intos/baskets`, {test: 'test'},{
          headers: {

          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'

          }})
          .then(response => {

            this.pagesToRemove = [];
            this.$parent.getOrder();

          })
          .catch(error =>{
            
            console.error(response);
            this.pagesToRemove = [];

          })

      }

    },

    countPageElements(page){

      let counter = 0;
      
      if(page.products){

        counter = counter + page.products.length;

      }

      
      if(page.productImages){

        counter = counter + page.productImages.length

      }

      return counter;

    },

  },
  watch:{

    item: function(){

      this.pages = [],
      this.countPages();
      this.activePage !=0 ? this.getPageComments() : this.getOrderComments();

    },

    switchActive: function(){

      this.activePage = this.switchActive;
      this.selectedPages = [{id: this.switchActive}];

    },

    id: function(){
      this.getOrderComments();
    },

    activePage: function(){

      this.activePage !=0 ? this.getPageComments() : this.getOrderComments();

    }

  },
  computed: {

    orderedPages: function () {

      return _.orderBy(this.pages, 'orderNumber')

    }

  },
  mounted(){

    this.originalPages = this.item;
    this.countPages();

  }
};
</script>

<style lang="scss" scoped>

.view-data__header--module h1{
  font-weight: 700;
  font-size: 14px;
}

.pages-grid{
  display: flex;
  flex-wrap: wrap;
  width:100%;
  max-height:350px;
  overflow-x: hidden;
  overflow-y: scroll;

  &.show-all{
    max-height: 100%;
    overflow-y: hidden;
  }

  &__item{

     &:nth-child(even){
      border-right: 2px #b4b4b4 solid;
    }
  }
}

.pages-list-item{
  width:50%;
  height:50px;
  border-bottom:2px #b4b4b4 solid;
  padding: 5%;
  display:flex;
  align-items: center;
  position:relative;
  cursor:move;

  &.active svg path{
    fill: #d3020c;
  }

  &.new svg path {
    fill: rgb(46, 204, 113);
  }

  &.product-changed svg path {
    fill: orange;
  }

  &:nth-child(even){
    flex-direction: row-reverse;

    & svg{
      -webkit-transform: scalex(-1);
 	   -moz-transform: scalex(-1);
	    -ms-transform: scalex(-1);
	     -o-transform: scalex(-1);
		    transform: scalex(-1);
         filter: flipv;
    }

    & p{
      left:auto;
    }
  }

  &:first-of-type, &:last-of-type{
    width:100%;
    justify-content: center;
    border-left: none;
    border-right: none;
    flex-direction: row !important;

    & .page-icon{
      margin-left: 10%;
    }
  }

  &:last-of-type{
     border:none;

     &.odd{
       width:50%;
       border-bottom:2px #b4b4b4 solid;
       justify-content:inherit;
       margin-left: 0px;

        & .page-icon{
          margin-left: 0%;
        }

       & svg{
        -webkit-transform: scalex(1);
        -moz-transform: scalex(1);
        -ms-transform: scalex(1);
        -o-transform: scalex(1);
        transform: scalex(1);
        filter: flipv;
       }
     }
  }
  

  & svg{
    display:block;
  }

  & p{
    position: absolute;
    color:#fff;
    top:10px;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      top:auto;
      right:13px;
      bottom:50px;
    }
  }

  & span{
      margin-left: 5%;
      align-self: flex-end;
      line-height: 16px;
  }
}

.page-icon{
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width:30px;
}

.pages-buttons{
  width:100%;
  display:flex;
  flex-direction: column;
  z-index: 10;

  & span{
    display:flex;
    align-items: center;
    justify-content: center;
    background:none;
    border:none;
    border-bottom:2px #b4b4b4 solid;
    padding: 10px 0px;
    max-height: 41px;
    font-weight: 400;
    position:relative;
    cursor:pointer;

    & img{
      position:absolute;
      display:block;
      width:10%;
      left:10%;
    }

    & .list-arrow{
      position:relative;
      transform: rotate(90deg);
      left:auto;
      opacity:0.5;

      &.expanded{
        transform: rotate(-90deg);
      }
    }

    &:nth-child(5){
      border-bottom:none;

      & img{
        max-height: 30px !important;
      }
    }
  }

  & p{
    position: absolute;
    right:5%;
    top:25%;
    margin:0;
  }
}

.comments{
  display:flex;
  flex-direction: column;

  &__list{
    list-style: none;
    margin:0;
    padding: 0;
    width:100%;

    & li{
      display:flex;
      width:100%;
      justify-content: space-between;
      position:relative;
      padding: 5px 0px;

      & span{
        width:12%;
        position:relative;

        & img{
          display:block;
          opacity: 0.5;
          width: 23px;
        }

        & p{
          position:absolute;
          top:0;
          left:8px;
          color:#fff;
          z-index: 2;
        }
      }

      & p{
        width:80%;
        margin: 0;
        padding: 0;
      }
    }
  }
}

.comment-btn{
  margin-top: 10px;
  cursor:pointer;
}

.bolded{
  font-weight: 700 !important;
}

.dropZonePage, .dropZonePageTrash{
  background:transparent;
  position: absolute;
  width:100%;
  height:100%;
  z-index: 15;
  opacity: 0;
}

.dropZonePageTrash{
  top:0;
  left:0;
  display:none;
}

</style>